import { Component, Inject, OnInit } from '@angular/core';

import { SESSION_STORAGE, WebStorageService } from 'ngx-webstorage-service';
import { AlertComponent } from 'ngx-bootstrap/alert';

import { InvoicementManhattan } from '../../../common/model/InvoicementManhattan';
import { Strings } from '../../../common/language/strings';
import { InvoicementDownloadFacade } from '../../../common/facade/InvoicementDownloadFacade';
import { Permissions } from '../../../common/model/dictionary/Permissions'
import { res } from '../../../common/language/text/res';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';

@Component({
  selector: 'app-invoicement-download',
  templateUrl: './invoicement-download.component.html',
  styleUrls: ['./invoicement-download.component.css']
})
export class InvoicementDownloadComponent implements OnInit {

  public loading = false;
	public messageLoader = this.strings.GetText(res.Loading);
	public txtMinDate = new Date(this.getNowUTC().getFullYear() - 6,
		this.getNowUTC().getMonth(),
		1,
		this.getNowUTC().getHours(),
		this.getNowUTC().getMinutes(),
		this.getNowUTC().getSeconds(),
		this.getNowUTC().getMilliseconds());
	public txtMaxDate = this.getNowUTC().setDate(this.getNowUTC().getDate());
	public txtStartDate = new Date();
	public txtEndDate = new Date();
	public isUSA = 'US30';
	public res = res;

	lblInvoicement = res.Invoicement;
	lblInvoice = res.Invoice;
	lblOrg = res.Organization;
	lblRequester = res.Requester;
	lblUnits = res.Units;
	lblInvoicementDate = res.InvoicementDate;
	lblStyleVariety = res.StyleVariety;
	lblDownload = res.Download;
	lblCreateDate = res.CreationDate;
	lblSearch = res.Search;
	lblInitDate = res.StartDate;
	lblFinalDate = res.EndDate;
	lblSelectAnOption = res.SelectAnOption;
	lblBox = res.BoxQuantity;

	visibleSearchControl = false;
	oldOrg = '';

	messagesTable: any = {
		emptyMessage: '',
		totalMessage: ''
	};

	visibleRead = false;
	visibleDownload = false;
	organization = -1

	rows: InvoicementManhattan[] = [];
	alertModal = [];
	lsInvoiceOrgs: any[] = [];

	private _filteredData: InvoicementManhattan[];

	constructor(
		public strings: Strings,
		@Inject(SESSION_STORAGE) private _storage: WebStorageService,
		private invoiceFacade: InvoicementDownloadFacade,
		private localeService: BsLocaleService
	) { }

	ngOnInit(): void {
		this.validatePermission();
		this.localeService.use(this.strings.getLanguage());
		this.messagesTable.emptyMessage = this.strings.GetText(res.ThereIsNoInformation);
		this.messagesTable.totalMessage = 'Total';
		this.GetOrgs();
	}

	validatePermission() {
		const permissionList = this._storage.get('permissions');

		permissionList.forEach(item => {
			this.visibleRead = item.name === Permissions.InvoicementRead;
			this.visibleDownload = item.name === Permissions.InvoicementDownload;
		});
	}

	addAlertModal(message: String, type: String): void {
		this.alertModal.push({
		  type: type,
		  msg: message,
		  timeout: 5000
		});
	  }

	onClosed(dismissedAlert: AlertComponent) {
		this.alertModal = this.alertModal.filter(alert => alert !== dismissedAlert);
	}

	updateFilter(event) {
		// get the value of the key pressed and make it lowercase
		const val = event.target.value.toLowerCase();
		// get the key names of each column in the dataset
		const keys = Object.keys(this._filteredData[0]);
		// assign filtered matches to the active datatable
		this.rows = this._filteredData.filter(item => {
			return keys.some(key => {
				return item[key] != null && (item[key].toString().toLowerCase().indexOf(val) !== -1 || !val);
			});
		});
	}

	private getNowUTC() {
		const now = new Date();
		return new Date(now.getTime() + (now.getTimezoneOffset() * 60000));
	}

	GetOrgs() {
		this.loading = true;
		this.invoiceFacade.GetComboOrgs().subscribe(result => {
			if (result.completed) {
				this.lsInvoiceOrgs = result.data;
			}
			this.loading = false;
		}, error => {
			this.loading = false;
			this.addAlertModal('<strong>¡Error!</strong> ' + error, 'danger');
			console.log(error);
			return;
		})
	}

	GetInformation(initialDate: string, finalDate: string, org: string) {
		this.loading = true;

		if(this.txtStartDate > this.txtEndDate){
			this.addAlertModal('<strong>¡Error!</strong> ' + this.strings.GetText(res.AlertTheStartDateCannotBeHigher), 'danger');
      		this.loading = false;
		}
		else {
			this.invoiceFacade.GetInvoicement(initialDate, finalDate, org).subscribe(result => {
				if (result.completed) {
					this.rows = result.data;
					this._filteredData = result.data;
	
					this.rows.forEach(item => {
						let dates = item.invoicementDate.split('T');
						const date = new Date(dates[0]);
	
						const day = date.getDate().toString().padStart(2, "0");
						const month = (date.getMonth() + 1).toString().padStart(2, "0");
						const year = date.getFullYear().toString();
						const formattedDate = `${day}/${month}/${year}`;
	
						item.invoicementDate = formattedDate;
					})
	
					this._filteredData = this.rows
				}
				this.loading = false;
			}, error => {
				this.loading = false;
				this.addAlertModal('<strong>¡Error!</strong> ' + error, 'danger');
				console.log(error);
				return;
			});
		}
	}

	onOrganizationChange() {
		const orgSelect = document.querySelector('#orgSelect') as HTMLSelectElement;
		const selectedOrgName = orgSelect.options[orgSelect.selectedIndex].text;

		if (this.organization != -1 && selectedOrgName != this.oldOrg) {
			this.oldOrg = selectedOrgName;
			this.visibleSearchControl = true;
		}
	}

	onChangeStartDate(value) {
		this.txtStartDate = this.subtractTimeFromDate(value, 6);
	}

	onChangeEndDate(value) {
		this.txtEndDate = this.subtractTimeFromDate(value, 6);
	}

	subtractTimeFromDate(objDate, intHours) {
		var numberOfMlSeconds = objDate.getTime();
		var addMlSeconds = intHours * 60 * 60000;
		var newDateObj = new Date(numberOfMlSeconds - addMlSeconds);
		return newDateObj;
	  }
}
